module.exports = __webpack_public_path__ + "img/step3.8ce03d79.png";